import { useTranslation } from 'react-i18next';
import SearchIcon from 'components/atoms/icons/search.svg?react';
import EmptyTablePlaceholder from 'components/atoms/base-empty-table-placeholder';
import BaseTableNew from 'components/atoms/base-table/new';
import BasePagination from 'components/atoms/base-pagination';
import useUser from 'utils/useUser';
import { Flex } from 'antd';

import s from './styles.module.scss';
import { useColumns } from './columns';
import { PAGE_SIZE } from '../../constants';
import MobileTable from './mobile-table';

import type { IRpmPatientActivity } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { FC } from 'react';

interface ReadingTableProps {
  page: number;
  setPage: (n: number) => void;
  activity: IRpmPatientActivity | undefined;
  isLoading: boolean;
  name: string;
}

const ReadingTable: FC<ReadingTableProps> = ({
  page,
  setPage,
  activity,
  isLoading,
  name,
}) => {
  const { isMobileDevice } = useUser();
  const columns = useColumns({ page, items: PAGE_SIZE, name });

  const { t } = useTranslation();

  if (isMobileDevice) {
    return (
      <>
        <MobileTable
          activity={activity}
          page={page}
          isLoading={isLoading}
          name={name}
        />
        <BasePagination
          page={page}
          total={activity?.count ?? 0}
          align="center"
          onChange={(newPage) => {
            setPage(newPage);
          }}
          pageSize={PAGE_SIZE}
          pageSizeOptions={[]}
          hide={false}
          showSizeChanger={false}
          className={s.pagination}
        />
      </>
    );
  }

  return (
    <Flex vertical className={s.wrapper}>
      <BaseTableNew
        dataCy="patient-readings-table"
        loading={isLoading}
        columns={columns}
        items={activity?.data ?? []}
        bordered={false}
        rowKey="guid"
        className={s.table}
        changeOddRowColor={false}
        emptyText={
          <EmptyTablePlaceholder
            text={t('labels.noReadingsFound')}
            icon={<SearchIcon width={100} height={100} />}
            column
          />
        }
        rowHoverable={false}
      />
      <Flex align="center" justify="end" className={s['pagination-wrapper']}>
        <BasePagination
          page={page}
          total={activity?.count ?? 0}
          align="end"
          onChange={(newPage) => {
            setPage(newPage);
          }}
          pageSize={PAGE_SIZE}
          pageSizeOptions={[]}
          hide={false}
          showSizeChanger={false}
        />
      </Flex>
    </Flex>
  );
};

export default ReadingTable;
